import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CaseStudyPage from "../pages/case-study/page";
import BlogPage from "../pages/blog/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import ReferencePage from "../pages/references/page";
import ObchodnePodmienkyPage from "../pages/legal/obchodne-podmienky/page";
import OchranaSukromiaPage from "../pages/legal/ochrana-sukromia/page";
import CookiesPage from "../pages/legal/cookies/page";
import AutorPage from "../pages/autor/page";
import ServiceLandingPage from "../pages/sluzby/page";
import TvorbaWebovPage from "../pages/tvorba-webov/page";
import DakujemePage from "../pages/dakujeme/page";
import KlientskyPortalPage from "../pages/klientsky-portal/page";
import PortalPage from "../pages/portal/page";
import AdminPortalPage from "../pages/admin-portal/page";
import UdrzbaPage from "../pages/udrzba/page";
import UzCoskoroPage from "../pages/uz-coskoro/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/case-study/salenbike",
    element: <CaseStudyPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:id",
    element: <ArticlePage />,
  },
  {
    path: "/o-nas",
    element: <AboutPage />,
  },
  {
    path: "/referencie",
    element: <ReferencePage />,
  },
  {
    path: "/obchodne-podmienky",
    element: <ObchodnePodmienkyPage />,
  },
  {
    path: "/ochrana-sukromia",
    element: <OchranaSukromiaPage />,
  },
  {
    path: "/cookies",
    element: <CookiesPage />,
  },
  {
    path: "/autor/:slug",
    element: <AutorPage />,
  },
  {
    path: "/sluzby/:slug",
    element: <ServiceLandingPage />,
  },
  {
    path: "/tvorba-webov",
    element: <TvorbaWebovPage />,
  },
  {
    path: "/dakujeme",
    element: <DakujemePage />,
  },
  {
    path: "/klientsky-portal",
    element: <KlientskyPortalPage />,
  },
  {
    path: "/portal",
    element: <PortalPage />,
  },
  {
    path: "/admin-portal",
    element: <AdminPortalPage />,
  },
  {
    path: "/udrzba",
    element: <UdrzbaPage />,
  },
  {
    path: "/uz-coskoro",
    element: <UzCoskoroPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
